export default {"src":"https://cloudflare.edhrec.com/_next/static/media/managwub.62564840.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};